export default {"src":"/_next/static/media/logo-storyblok.a5e87bcd.svg","height":26,"width":123,"blurWidth":0,"blurHeight":0};